module.exports = __webpack_public_path__ + "media/MRI19C.1e1cbe5f.mp3";